import { render, staticRenderFns } from "./SocialPlatform.vue?vue&type=template&id=6f058672"
import script from "./SocialPlatform.vue?vue&type=script&lang=js"
export * from "./SocialPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports